import * as React from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { Outlet } from "react-router-dom";
import SidebarHeader from "./sidebar-header";
import Sidebar from "./sidebar";
import { useAuth } from "../auth/identity-auth0-context";

const SidebarLayout = ({ children }: { children?: React.ReactNode }) => {
  const { isAuthenticated, userRoles, hasClientId } = useAuth();

  const [isNavigationExpanded, setIsNavigationExpanded] = React.useState(false);
  const layoutRef = React.useRef<HTMLDivElement>(null);

  const handleToggleHeaderMenu = React.useCallback(
    (isExpanded: boolean) => {
      setIsNavigationExpanded(isExpanded);
    },
    [setIsNavigationExpanded],
  );

  return isAuthenticated && (userRoles?.length ?? 0) > 0 && hasClientId ? (
    <Box
      ref={layoutRef}
      sx={{
        position: "relative",
        display: "flex",
        overflow: "hidden",
        height: "100vh",
        width: "100%",
      }}
    >
      <SidebarHeader
        title="DTECTION"
        menuOpen={isNavigationExpanded}
        onToggleMenu={handleToggleHeaderMenu}
      />
      <Sidebar expanded={isNavigationExpanded} />
      <Box
        data-testid="sidebar-content-layout"
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minWidth: 0,
        }}
      >
        <Toolbar sx={{ displayPrint: "none" }} />
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            overflow: "auto",
          }}
        >
          {children || <Outlet />}
        </Box>
      </Box>
    </Box>
  ) : (
    children
  );
};

export default SidebarLayout;
